import ReactPaginate from "react-paginate";

const Pagination = ({ pageCount, onPageChange, currentPage }) => {
  return (
    <div className="mt-6 flex justify-center dark:text-white" data-testid="pagination">
      <ReactPaginate
        pageCount={pageCount}
        onPageChange={onPageChange}
        forcePage={currentPage}
        containerClassName="flex flex-wrap gap-2 text-sm sm:text-base"
        pageLinkClassName="px-3 py-1 border rounded-lg cursor-pointer hover:bg-gray-100 dark:hover:text-black transition"
        activeLinkClassName="bg-blue-500 text-white hover:text-black border-blue-500"
        previousLinkClassName="px-3 py-1 border rounded-lg cursor-pointer hover:bg-gray-100 dark:hover:text-black transition"
        nextLinkClassName="px-3 py-1 border rounded-lg cursor-pointer hover:bg-gray-100 dark:hover:text-black transition"
        disabledLinkClassName="opacity-50 cursor-not-allowed"
        previousLabel="← Prev"
        nextLabel="Next →"
        breakLabel="..."
      />
    </div>
  );
};

export default Pagination;
